
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type HeaderFacetPanelContainerRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function HeaderFacetPanelContainerRT(): TemplateResult<HeaderFacetPanelContainerRTRootProps> {
    return _createElement('div', { 'className': 'cm_FacetPanel__header-desktop cm_mobile-hide' }, [this.HeaderFacetPanel(function () {
            return _createElement('div', { 'className': 'cm_facet-tiles cm_HeaderFacetPanel' }, [this.facets(function () {
                    function repeatFacets1(facets, facetsIndex) {
                        return [facets(function () {
                                return this.field !== 'diameter' || this.field === 'diameter' && window.Convermax.isVehicleSelected() ? _createElement('div', {
                                    'onTouchStart': e => window.Convermax.handleCollapseMobileContent(e),
                                    'className': 'cm_facet-title cm_field-' + this.field + ' collapsed cm_desktop-hide',
                                    'key': '5'
                                }, '\n      ', this.name, '\n      ', [_createElement('svg', {
                                        'className': 'cm_icon cm_plus',
                                        'width': '29',
                                        'height': '29',
                                        'viewBox': '0 0 29 29',
                                        'fill': 'none',
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'key': '3120'
                                    }, _createElement('line', {
                                        'x1': '14',
                                        'x2': '14',
                                        'y2': '29',
                                        'stroke': '#2D2D2D',
                                        'strokeWidth': '8'
                                    }), _createElement('line', {
                                        'y1': '15',
                                        'x2': '29',
                                        'y2': '15',
                                        'stroke': '#2D2D2D',
                                        'strokeWidth': '8'
                                    }), _createElement('line', {
                                        'x1': '18.5',
                                        'x2': '18.5',
                                        'y2': '29',
                                        'stroke': '#2D2D2D'
                                    }))], [_createElement('svg', {
                                        'className': 'cm_icon cm_minus',
                                        'width': '29',
                                        'height': '8',
                                        'viewBox': '0 0 29 8',
                                        'fill': 'none',
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'key': '6600'
                                    }, _createElement('line', {
                                        'y1': '4',
                                        'x2': '29',
                                        'y2': '4',
                                        'stroke': '#2D2D2D',
                                        'strokeWidth': '8'
                                    }))]) : null;
                            }, { count: undefined })];
                    }
                    function repeatFacets2(facets, facetsIndex) {
                        return [facets(function () {
                                function repeatShowAlwaysValues1(ShowAlwaysValues, ShowAlwaysValuesIndex) {
                                    return [ShowAlwaysValues(function () {
                                            return _createElement('div', {
                                                'onClick': e => window.Convermax.handleClickEvent(e),
                                                'className': 'cm_button' + (this.isSelected ? ' cm_selected btn btn--primary' : ' btn btn--secondary') + (this.imageUrl ? ' cm_button-image' : ' cm_button-text')
                                            }, !this.imageUrl ? _createElement('span', { 'key': '281' }, this.value) : null, this.imageUrl ? _createElement('img', {
                                                'className': 'cm_image',
                                                'src': this.imageUrl,
                                                'onError': event => event.target.removeAttribute('src'),
                                                'key': '344'
                                            }) : null);
                                        }, { count: undefined })];
                                }
                                return this.field !== 'diameter' || this.field === 'diameter' && window.Convermax.isVehicleSelected() ? _createElement('div', {
                                    'className': 'cm_facet-facetbody-container',
                                    'key': '5'
                                }, _createElement('div', { 'className': 'cm_facet-title cm_mobile-hide' }, 'By ', this.name), _createElement('div', { 'className': 'cm_facet-facetbody cm_facet-facetbody-' + this.field + ' collapsed' }, this.template === 'simpleFacet' ? _createElement('div', {
                                    'className': 'cmTemplate_simpleFacet',
                                    'key': '338'
                                }, this.values.length > 5 ? _createElement('button', {
                                    'onClick': e => window.Convermax.handleArrows(e, true),
                                    'className': 'cm_arrow-left cm_mobile-hide',
                                    'key': '435'
                                }, [_createElement('svg', {
                                        'className': 'cm_icon',
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'width': '163',
                                        'height': '283',
                                        'viewBox': '0 0 163 283',
                                        'fill': 'none',
                                        'key': '5880'
                                    }, _createElement('path', {
                                        'd': 'M13 13L148.745 152.994',
                                        'stroke': '#2D2D2D',
                                        'strokeWidth': '36'
                                    }), _createElement('path', {
                                        'd': 'M148.464 129L14 270.225',
                                        'stroke': '#2D2D2D',
                                        'strokeWidth': '36'
                                    }), _createElement('rect', {
                                        'x': '161.027',
                                        'y': '139.818',
                                        'width': '1.44539',
                                        'height': '1.48042',
                                        'transform': 'rotate(43.9223 161.027 139.818)',
                                        'fill': '#2D2D2D'
                                    }))]) : null, _createElement.apply(this, [
                                    'div',
                                    {
                                        'onMouseEnter': e => window.Convermax.handleWheelScrollEvent(e),
                                        'onMouseDown': e => window.Convermax.handleMouseDownEvent(e),
                                        'onMouseMove': e => window.Convermax.handleMouseMoveEvent(e),
                                        'onMouseLeave': e => window.Convermax.handleMouseLeaveEvent(e),
                                        'onMouseUp': e => window.Convermax.handleMouseUpEvent(e),
                                        'className': 'cm_button-container cmRepeater_ShowAlwaysValues'
                                    },
                                    _map(this.ShowAlwaysValues, repeatShowAlwaysValues1.bind(this))
                                ]), this.values.length > 5 ? _createElement('button', {
                                    'onClick': e => window.Convermax.handleArrows(e, false),
                                    'className': 'cm_arrow-right cm_mobile-hide',
                                    'key': '2278'
                                }, [_createElement('svg', {
                                        'className': 'cm_icon',
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'width': '163',
                                        'height': '283',
                                        'viewBox': '0 0 163 283',
                                        'fill': 'none',
                                        'key': '24330'
                                    }, _createElement('path', {
                                        'd': 'M13 13L148.745 152.994',
                                        'stroke': '#2D2D2D',
                                        'strokeWidth': '36'
                                    }), _createElement('path', {
                                        'd': 'M148.464 129L14 270.225',
                                        'stroke': '#2D2D2D',
                                        'strokeWidth': '36'
                                    }), _createElement('rect', {
                                        'x': '161.027',
                                        'y': '139.818',
                                        'width': '1.44539',
                                        'height': '1.48042',
                                        'transform': 'rotate(43.9223 161.027 139.818)',
                                        'fill': '#2D2D2D'
                                    }))]) : null) : null)) : null;
                            }, { count: undefined })];
                    }
                    return _createElement('div', { 'className': 'cm_facets' }, _createElement.apply(this, [
                        'div',
                        { 'className': 'cm_facet-title-container cmRepeater_facets' },
                        _map(this.facets, repeatFacets1.bind(this))
                    ]), _createElement.apply(this, [
                        'div',
                        { 'className': 'cm_facets-content cmRepeater_facets' },
                        _map(this.facets, repeatFacets2.bind(this))
                    ]));
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })]);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:facets","cm:HeaderFacetPanel"]